<template>
  <section class="side-block block-colleague" :data-theme="themes[colorTheme ?? DataThemes._0]">
    <div class="block-colleague__top">
      <figure class="avatar">
        <img
          v-if="profilePicture.value && profilePicture.value?.url"
          width="150"
          loading="lazy"
          :src="profilePicture.value.url + '?w=150'"
          :alt="profilePicture.value.alt ?? ''" />
      </figure>
      <div class="block-colleague__name">
        <h3>{{ personName }}</h3>
        <em>{{ jobTitle.value }}</em>
      </div>
    </div>
    <p>{{ contactMe.value }}</p>
    <address>
      <NuxtLink
        v-if="phoneNumber.value"
        v-bind="useEpiAttrs(phoneNumber)"
        :to="`tel:${phoneNumber.value}`"
        class="more-link">
        {{ phoneNumber.value }}
      </NuxtLink>
      <NuxtLink
        v-if="email.value"
        v-bind="useEpiAttrs(email)"
        :to="`mailto:${email.value}`"
        class="more-link">
        {{ email.value }}
      </NuxtLink>
    </address>
  </section>
</template>

<script lang="ts" setup>
import type { PersonBlock } from '@base/types/models';
import { themes } from '@base/utils/theme';
import { DataThemes } from '@api';

const props = defineProps<PersonBlock>();

const personName = computed(
  () =>
    `${props.firstName.value ?? ''} ${props.middleName.value ?? ''} ${props.lastName.value ?? ''}`
);
</script>

<style lang="scss" scoped>
.side-block {
  border-radius: px(12);
  width: 100%;
  margin-bottom: px(8);
  padding: px(24) px(16);
  color: var(--theme-color);
  background-color: var(--theme-bg-color);

  h1,
  h2,
  h3 {
    color: inherit;
  }

  &::before,
  &::after {
    content: '';
    display: table;
  }

  &::after {
    clear: both;
  }

  @include media-breakpoint-up(lg) {
    padding: px(48);
  }
}

.block-colleague {
  display: block;

  &__top {
    display: flex;
    flex-wrap: wrap;

    .avatar {
      width: px(80);
      height: px(80);
      margin: px(-12) px(12) px(12) 0;
    }
  }

  &__name {
    flex: 1;
    margin-bottom: px(24);
  }

  p {
    margin-bottom: px(24);
  }

  .more-link {
    display: block;
  }

  @include media-breakpoint-up(lg) {
    p {
      margin-bottom: px(32);
    }

    &__top {
      .avatar {
        width: px(148);
        height: px(148);
        margin: px(-24) px(16) px(24) 0;
      }
    }
  }
}
</style>
